'use client';
import React from 'react';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import { Box, List, ListItem, Stack } from '@mui/material';
import { getAosDelay, mergeAos, zoomInAosProps } from '@utils/aosProps';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import CommonContainer from '@components/CommonContainer';
import CustomImage from '@components/CustomImage';

import cn from './style.module.scss';
export default function EastvaleConnected(props: MarketingPageComponentProps) {
  const connectedSection = props?.locale?.section?.find(
    (section: any) => section.type === 'connected' && section.enabled
  );
  if (!connectedSection) return null;
  const eastvaleConnectedElementData =
    connectedSection?.eastvaleConnectedFeatures ?? [];
  return (
    <Stack component="section" className={cn.eastvaleConnectedWrapper}>
      <Box className={cn.eastvaleConnectedBlock}>
        <CommonContainer
          paddingInline={{ xs: '32px', sm: '32px', md: '24px' }}
          maxWidth={{ xs: '100%', md: '1200px', lg: '1400px' }}
          flexGrow={1}
        >
          <Box className={cn.eastvaleConnectedContent}>
            <Box className={cn.eastvaleConnectedHeader}>
              <Box className={cn.eastvaleConnectedHeader__title}>
                <ParallaxText
                  variant="h2"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(connectedSection?.eastvaleConnectedHeading)}
                </ParallaxText>
              </Box>
              <Box className={cn.eastvaleConnectedHeader__data}>
                <ParallaxText
                  variant="p"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(connectedSection?.eastvaleConnectedContent)}
                </ParallaxText>
              </Box>
            </Box>
            <Box className={cn.eastvaleConnectedList}>
              <List className={cn.connectedListElement}>
                {eastvaleConnectedElementData.map(
                  (feature: any, index: number) => (
                    <ListItem key={index} className={cn.connectedListItem}>
                      <Box
                        className={cn.connectedItemPane}
                        {...mergeAos(
                          zoomInAosProps,
                          getAosDelay(200 + index * 5)
                        )}
                      >
                        <Box className={cn.connectedListIcon}>
                          <CustomImage
                            src={feature.icon}
                            alt={feature.alt}
                            width={40}
                            height={40}
                          />
                        </Box>
                        <Box className={cn.connectedListData}>
                          <ParallaxText
                            variant="h4"
                            animationType="zoomIn"
                            animationDuration={500}
                          >
                            {ReactHtmlParser(feature.title)}
                          </ParallaxText>
                          <ParallaxText
                            variant="p"
                            animationType="zoomIn"
                            animationDuration={500}
                          >
                            {ReactHtmlParser(feature.description)}
                          </ParallaxText>
                        </Box>
                      </Box>
                    </ListItem>
                  )
                )}
              </List>
            </Box>
          </Box>
        </CommonContainer>
        <Box className={cn.eastvaleConnectedMap}>
          <CustomImage
            src={connectedSection.eastvaleConnectedMap}
            alt={connectedSection.eastvaleConnectedMap}
            width={1200}
            height={800}
          />
        </Box>
      </Box>
    </Stack>
  );
}
